import { ItemNoAndTypeWithOrderedDetails } from "./TaskDetailTypes";

export interface CheckboxFieldConfig {
  id: "pieces_ordered" | "ptags_ordered";
  fieldPath: "pieces_ordered" | "ptags_ordered";
  translationKey: string;
}

export interface OrderedDetailsMode {
  id: "pieces" | "ptags" | "both";
  titleTranslationKey: string;
  subTitleTranslationKey: string;
  fields: CheckboxFieldConfig[];
  getTotalQuantity: (items: ItemNoAndTypeWithOrderedDetails[]) => number;
  totalTranslationKey: string;
}

export const ORDERED_DETAILS_MODES = {
  pieces: {
    id: "pieces",
    titleTranslationKey: "getNewArticlesString",
    subTitleTranslationKey: "writeOffArticleWithSGFString",
    fields: [
      {
        id: "pieces_ordered",
        fieldPath: "pieces_ordered",
        translationKey: "getPiecesString",
      },
    ] as const,
    getTotalQuantity: (items: ItemNoAndTypeWithOrderedDetails[]) =>
      items.reduce((acc, item) => acc + item.pieces_ordered.quantity, 0),
    totalTranslationKey: "piecesCountString",
  } as const satisfies OrderedDetailsMode,
  ptags: {
    id: "ptags",
    titleTranslationKey: "printPTagsString",
    subTitleTranslationKey: "selectRightCarrierInPtagString",
    fields: [
      {
        id: "ptags_ordered",
        fieldPath: "ptags_ordered",
        translationKey: "pTagsString",
      },
    ] as const,
    getTotalQuantity: (items: ItemNoAndTypeWithOrderedDetails[]) =>
      items.reduce((acc, item) => acc + item.ptags_ordered.quantity, 0),
    totalTranslationKey: "piecesCountString",
  } as const satisfies OrderedDetailsMode,
  both: {
    id: "both",
    titleTranslationKey: "getNewArticlesString",
    subTitleTranslationKey: "writeOffArticleWithSGFString",
    fields: [
      {
        id: "pieces_ordered",
        fieldPath: "pieces_ordered",
        translationKey: "getPiecesString",
      },
      {
        id: "ptags_ordered",
        fieldPath: "ptags_ordered",
        translationKey: "pTagsString",
      },
    ] as const,
    getTotalQuantity: (items: ItemNoAndTypeWithOrderedDetails[]) => {
      const piecesTotal = items.reduce(
        (acc, item) => acc + item.pieces_ordered.quantity,
        0
      );
      const ptagsTotal = items.reduce(
        (acc, item) => acc + item.ptags_ordered.quantity,
        0
      );
      return piecesTotal + ptagsTotal;
    },
    totalTranslationKey: "piecesCountString",
  } as const satisfies OrderedDetailsMode,
} as const;
